// extracted by mini-css-extract-plugin
export default {"aboutMeModal":"AboutMeModal_aboutMeModal__Gnpsw","h1":"AboutMeModal_h1__AVEK7","p":"AboutMeModal_p__xaqOn"};